export default __webpack_public_path__ + "static/media/Scissors.978b08d4.png";